export default "__VITE_ASSET__CGOMLMDt__"